import { DropdownOption } from 'components/final-form/dropdownUtils';
import React, { Component } from 'react';
import { MessageSourceProps, withMessages } from 'react-message-source';
import { Grid } from 'semantic-ui-react';
import CheckBox from 'components/final-form/CheckBox';
import Select from 'components/final-form/Select';
import { Field } from 'react-final-form';
import { CancelTokenSource } from 'axios';
import axios from 'services/http';
import { DoctorDto } from 'ts-types/api.types';
import { searchDoctorsForInput } from 'services/doctorServices';
import PraxFormGrid from 'components/layout/PraxFormGrid';

interface Props extends MessageSourceProps {
  doctors: Array<DropdownOption>,
  representingDoctorsVisible: boolean,
  referralDoctorVisible: boolean,
  readOnly: boolean
}

interface State {
  representingDoctorsVisible: boolean,
  referralDoctorVisible: boolean,
  cancelTokenSource: CancelTokenSource
}

class DoctorsSegment extends Component<Props, State> {

  constructor(props: Props) {
    super(props);

    const {representingDoctorsVisible, referralDoctorVisible} = this.props;

    this.state = {
      representingDoctorsVisible: representingDoctorsVisible,
      referralDoctorVisible: referralDoctorVisible,
      cancelTokenSource: axios.CancelToken.source()
    }
  }

  toggleRepresentingDoctorsVisibility = () => {
    this.setState(({representingDoctorsVisible}: State) => ({
      representingDoctorsVisible: !representingDoctorsVisible
    }))
  };

  toggleReferralDoctorsVisibility = () => {
    this.setState(({referralDoctorVisible}: State) => ({
      referralDoctorVisible: !referralDoctorVisible
    }))
  };

  mapDoctors = (doctors: Array<DoctorDto>): Array<DropdownOption> => {
    return doctors.map(doctor => ({
      key: doctor.id,
      text: `${doctor.name} ${doctor.firstName} - ${doctor.city}`,
      value: doctor.id
    }));
  };

  searchDoctors = (search: string): Promise<Array<DoctorDto>> => {

    const {cancelTokenSource} = this.state;

    return searchDoctorsForInput(search, cancelTokenSource, 75);
  };

  render(): React.ReactNode {

    const {doctors, getMessage, readOnly} = this.props;
    const {representingDoctorsVisible, referralDoctorVisible} = this.state;

    const displayRepresentingDoctors = representingDoctorsVisible ? "flex" : "none";
    const displayReferralDoctors = referralDoctorVisible ? "flex" : "none";

    return (
        <PraxFormGrid>
          <Grid.Row>
            <Grid.Column>
              <h4>{getMessage('doctors')}</h4>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={8}>
              <Field
                  name="representingDoctor"
                  component={CheckBox}
                  label={`${getMessage('treatmentForm.representing')}`}
                  onClick={this.toggleRepresentingDoctorsVisibility}
                  disabled={readOnly}
              />
            </Grid.Column>
            <Grid.Column width={8}>
              <Field
                  name="referralDoctor"
                  component={CheckBox}
                  label={`${getMessage('treatmentForm.referral')}`}
                  onClick={this.toggleReferralDoctorsVisibility}
                  disabled={readOnly}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row style={{display: displayRepresentingDoctors}}>
            <Grid.Column width={4}>
              {getMessage('treatmentForm.representing')}
            </Grid.Column>
            <Grid.Column width={11}>
              <Field
                  name="representingDoctorId"
                  component={Select}
                  placeholder={getMessage('doctor')}
                  options={doctors}
                  remoteSearchMethod={this.searchDoctors}
                  searchResultToOptionMapper={this.mapDoctors}
                  disabled={readOnly}
                  remoteSearch
                  upward
                  fluid
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row style={{display: displayReferralDoctors}}>
            <Grid.Column width={4}>
              {getMessage('treatmentForm.referral')}
            </Grid.Column>
            <Grid.Column width={11}>
              <Field
                  name="referralDoctorId"
                  component={Select}
                  placeholder={getMessage('doctor')}
                  options={doctors}
                  remoteSearchMethod={this.searchDoctors}
                  searchResultToOptionMapper={this.mapDoctors}
                  disabled={readOnly}
                  remoteSearch
                  upward
                  fluid
              />
            </Grid.Column>
          </Grid.Row>
        </PraxFormGrid>
    );
  }
}

export default withMessages(DoctorsSegment);
